var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWind(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8011 10.5007H4.38444C2.71777 10.5007 1.46777 9.25065 1.46777 7.58398C1.46777 5.91732 2.71777 5.08398 4.38444 5.08398C6.05111 5.08398 6.88444 5.91732 7.30111 7.16732M19.8011 14.2506H7.71777C6.05111 14.2506 4.80111 15.5006 4.80111 17.1673C4.80111 18.834 6.05111 19.6673 7.71777 19.6673C9.38444 19.6673 10.2178 18.834 10.6344 17.584M19.8011 6.75065H12.7178C11.0511 6.75065 9.80111 5.50065 9.80111 3.83398C9.80111 2.16732 11.0511 1.33398 12.7178 1.33398C14.3844 1.33398 15.2178 2.16732 15.6344 3.41732",
    stroke: "#4E4B66",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWind);
export default __webpack_public_path__ + "static/media/wind.37aef05628d64655bbb886abd2025df7.svg";
export { ForwardRef as ReactComponent };